export class AccLedgarMaster {
    public LEDGER_ID!: number;
    public LEDGER_CODE!: string;
    public LEDGER_CODE_MANL!: string;
    public LEDGER_NAME!: string;
    public LEDGER_ALIAS!: string;
    public GROUP_UNDER!: string;
    public LEDGAR_TYPE!: string;
    public LEDGAR_REF_CODE!: string;
    public LEDGAR_REF_ID!: number;
    public LEDGER_OPN_BALANCE!: number;
    public OPEN_BALANCE_CRDR!: string;
    public LEDGER_CLOS_BALANCE!: number;
    public LEDGER_CONT_NAME!: string;
    public LEDGER_CONT_ADD!: string;
    public LEDGER_CONT_CITY!: string;
    public LEDGER_CONT_PHONE!: string;
    public LEDGER_CONT_PHONE2!: string;
    public LEDGER_CONT_FAX!: string;
    public LEDGER_CONT_EMAIL!: string;
    public LEDGER_CONT_EMAIL2!: string;
    public LEDGER_CONT_WEB!: string;
    public LEDGER_INCTAX!: string;
    public LEDGER_SALETAX!: string;
    public LEDGER_CSALETAX!: string;
    public LEDGER_VAT!: string;
    public LEDGER_CREDITLIMIT!: number;
    public LEDGER_CREDITPERIOD!: number;
    public LEDGER_INTPER!: number;
    public LEDGER_DEPPER!: number;
    public LEDGER_MANT_BILLWISE_DETAIL!: number;
    public LEDGER_CHQMANDT!: number;
    public LEDGER_SRNO!: number;
    public LEDGER_PREVYEARAMOUNT!: number;
    public AUDIT!: number;
    public LEDGER_CLOS_BALANCE2!: number;
    public LEDGER_DEPPER2!: number;
    public LEDGER_NARRATION!: string;
    public BSR_CODE!: string;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string;
    public UPDATED_DATE!: string;
    public IS_ACTIVE!: boolean;
}

